import React from 'react';
import PropTypes from 'prop-types';
import { ContainerWrapper, OverlayLayer, LoadingContentWrapper } from './components/LoadingContainerStyles';
import Loading from '../../atoms/Loading';

const LoadingContainer = ({ loading, children, opacity, minHeight }) => {
  return (
    <ContainerWrapper minHeight={minHeight}>
      {loading && (
        <OverlayLayer opacity={opacity}>
          <Loading size="lg" />
        </OverlayLayer>
      )}
      <LoadingContentWrapper>
        {children}
      </LoadingContentWrapper>
    </ContainerWrapper>
  );
};

LoadingContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  opacity: PropTypes.number,
  minHeight: PropTypes.string,
};

LoadingContainer.defaultProps = {
  opacity: 0.7,
  minHeight: undefined,
};

export default LoadingContainer;



// WEBPACK FOOTER //
// ./src/design-system/molecules/LoadingContainer/LoadingContainer.jsx